'use strict';

var App = App || {
    interfaceName: $(document.body).data('interface-name')
};

$('html').removeClass('no-js').addClass('js');

var $ = $ || {};

App.fancyboxStyle = {
    // margin:     20,
    padding:    4,
    // fitToView:  false,
    // autoCenter: false,
    // helpers: {
    //     overlay: {
    //         locked: true
    //     }
    // }
};

$(function() {

    objectFitImages(); // вызовем полифил для object-fit

    App.init();
    App.AjaxBox.init();
    App.AjaxForms();
    App.FormMasks();
    App.FormPlaceholders();
    App.Popup.init();
    App.Buttons();
    App.Folding();
    App.Gallery();
    App.AjaxGallery();

    if ( App.interfaceName == 'home_page' ) {
        App.HomeParallax.init();
    }

    if ( App.interfaceName == 'gallery_cat' ) {
        App.Galleries();
    }

    if ( App.interfaceName == 'programs_cat'
      || App.interfaceName == 'tag' ) {
        App.ProgramFilters();
    }

    if ( App.interfaceName == 'services_group'
      || App.interfaceName == 'program'
    ) {
        App.Services();
    }

    App.SeasonSwitcher();

    $('.js-fancy').fancybox();

});

App.Buttons = function() {

    $('.js-menu-button').click(function() {
        var content = $('#template-menu').html();
        App.Popup.show(content, 'left');
    });

    $('.js-phone-button').click(function() {
        var content = $('#template-phone').html();
        App.Popup.show(content, 'right');
    });

};

App.FormMasks = function( context ) {

    var $context = $(context || document.body);

    $context.find('input[name=phone]', this).mask('+7 (999) 999 9999');

};

App.FormPlaceholders = function( context ) {

    var $context = $(context || document.body);

    if ( App.elementSupportsAttribute('input', 'placeholder') ) {
        $context.find('.form').each(function() {
            /* $(this).find('.form__field')
                .filter('.short_text, .long_text, .e_mail')
                .find('.form__label').hide(); */
            $(this).find('.form__field')
                .filter('.short_text, .long_text, .e_mail')
                .each(function() {
                    var $label = $(this).find('.form__label').hide();
                    var placeholder = $label.text()
                        // .replace('*', '');
                        .replace(/\s+/g, ' ');
                    placeholder = $.trim(placeholder);
                    $(this).find(':input').prop('placeholder', placeholder);
                });
        });
    }

};

App.HomeParallax = (function() {

    var // $wrapper,
        $scene,
        $list,
        $popup,
        $popupClose,
        $popupItem = $();

    // var popupMarginLeft;

    var popupClosedSize = 0,
        popupAnimationDuration = 300,
        popupCloseAnimationDuration = 100;

    var objects = [];

    function init() {

        // $wrapper    = $('.wrapper');
        $scene      = $('#home-scene');
        $list       = $('#home-list');
        $popup      = $('#home-popup');
        $popupClose = $popup.find('.home__popup-close');

        // popupMarginLeft = $popup.outerWidth() / 2;

        initParallax();

        initItems();

        $(document).mousemove(mouseMove);

        setInterval(mouseMove, 0.5);

        $popupClose.click(function() {
            closePopup();
            App.AjaxBox.close();
        });

    }

    function initParallax() {

        $scene.parallax({
            // calibrateX: true,
            // calibrateY: true,
            // invertX: false,
            // invertY: true,
            // limitX: false,
            // limitY: 10,
            scalarX: 10,
            scalarY: 5,
            // frictionX: 1,
            // frictionY: 1,
            originX: 0.5,
            originY: 0.5,
        });

    }

    function initItems() {

        $scene.find('.home__layer').each(function() {

            var $layer = $(this);

            var object = {
                $layer: $layer,
                $items: $layer.find('.home__item').clone().appendTo($list)
            };

            object.$items.click(itemClick);

            objects.push(object);

        });

        // $list.on('mouseenter', '.home__item', function() { $(this).addClass('is-hover'); });

    }

    function mouseMove() {

        $.each(objects, function( index, object ) {
            if (!object.$items.is(':visible')) return;
            var transformValue = getTransform(object.$layer);
            object.$items.css(transformProp, transformValue);
        });

        if ( $popupItem.length ) {
            var transformValue = getTransform($popupItem);
            $popup.css(transformProp, transformValue);
        }

    }

    function itemClick() {

        var $item = $(this);

        var fnShowPopup = function() {

            $popupItem.removeClass('is-active');
            $popupItem = $item;
            $popupItem.addClass('is-active');

            var transformValue = getTransform($popupItem);
            $popup.css(transformProp, transformValue);

            var popupItemWidth = $popupItem.width();
            var popupItemHeight = $popupItem.height();

            var popupSize = (popupItemWidth + popupItemHeight) / 2;

            var top = parseInt($popupItem.css('top')) + popupItemHeight / 2;
            var marginLeft = parseInt($popupItem.css('margin-left')) + popupItemWidth / 2;

            $popup.css({
                width:      popupClosedSize,
                height:     popupClosedSize,
                top:        top,
                marginLeft: marginLeft - popupClosedSize / 2,
                marginTop:  - popupClosedSize / 2,
                opacity:    0,
            }).show().animate({
                width:      popupSize,
                height:     popupSize,
                marginLeft: marginLeft - popupSize / 2,
                marginTop:  - popupSize / 2,
                opacity:    1,
            }, popupAnimationDuration, function() {
                $popupClose.fadeIn(popupCloseAnimationDuration);
            });

        };

        if ( $popup.is(':visible') ) {

            $popupClose.fadeOut(popupCloseAnimationDuration, function() {
                $popup.animate({
                    width:      popupClosedSize,
                    height:     popupClosedSize,
                    marginLeft: parseInt($popup.css('margin-left')) + $popup.width() / 2 - popupClosedSize / 2,
                    marginTop:  - popupClosedSize / 2,
                    opacity:    0,
                }, 100 || popupAnimationDuration, fnShowPopup);
            });

        } else {

            fnShowPopup();

        }

        var params = { group_id: $(this).data('id') };

        App.getJSON('get_services', params, function( data ) {

            App.AjaxBox.show(data.content, function( $context ) {



            }, function() {

                closePopup();

            });

        });

    }

    function closePopup() {

        $popupItem.removeClass('is-active');

        $popupClose.fadeOut(popupCloseAnimationDuration, function() {
            // $popup.fadeOut(popupAnimationDuration, function() {
            //     $popupItem = $();
            // });
            $popup.animate({
                width:      popupClosedSize,
                height:     popupClosedSize,
                marginLeft: parseInt($popup.css('margin-left')) + $popup.width() / 2 - popupClosedSize / 2,
                marginTop:  - popupClosedSize / 2,
                opacity:    0,
            }, popupAnimationDuration, function() {
                $popupItem = $();
            });
        });

    }

    function getTransform( $el ) {

        var matrix = $el.css(transformProp);
        var values = matrix.match(/-?[\d\.]+/g);
        // console.log(values[4] + ' ' + values[5]);

        return 'translate3d(' + values[4] + 'px, ' + values[5] + 'px, 0px)';

    }

    // http://stackoverflow.com/questions/8889014/setting-vendor-prefixed-css-using-javascript
    var transformProp = (function() {
        var testEl = document.createElement('div');
        if (testEl.style.transform == null) {
            var vendors = ['Webkit', 'Moz', 'ms'];
            for (var vendor in vendors) {
                if (testEl.style[ vendors[vendor] + 'Transform' ] !== undefined) {
                    // return vendors[vendor] + 'Transform';
                    return '-' + vendors[vendor].toLowerCase() + '-transform';
                }
            }
        }
        return 'transform';
    })();

    return {
        init: init
    };

})();

App.Galleries = function() {

    var $wrap = $('.galleries');
    var $links = $wrap.find('.galleries__groups-item');
    var $items = $wrap.find('.galleries__item').filter(':not(:empty)');

    $links.click(function() {
        var $link = $(this);
        if ($link.hasClass('is-active')) return;
        filter($link);
    });

    var $link = $links.filter('.is-active');
    if ( $link.length ) filter($link);

    function filter( $link ) {

        var type = $link.data('type');

        $links.filter('.is-active').removeClass('is-active');
        $link.addClass('is-active');

        $items.each(function() {
            var $item = $(this);
            $item.toggle($item.data('type') === type);
        });

    }

};

App.Gallery = function() {

    var $gallery = $('.gallery');

    if ( $gallery.length ) {

        var $nav = $gallery.find('.gallery__nav');

        if ( $gallery.hasClass('m--wide') ) {

            $nav.find('.gallery__nav-item.m--fake').remove();

            $nav.slick({
                infinite: true,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

        }

        if ( $gallery.hasClass('m--slider') ) {

            $nav.slick({
                infinite: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
            });

        }

    }

};

App.AjaxGallery = function() {

    $('.js-ajax-gallery-button').click(function() {

        var params = { gallery_id: $(this).data('gallery-id') };

        App.getJSON('get_gallery', params, function( data ) {

            var contentFor = '',
                contentNav = '';

            $.each(data.gallery, function() {

                contentFor += '\
                    <div class="gallery__for-item">\
                        <div class="gallery__for-image" style="background-image: url(\'' + this.src + '\');">\
                            <img src="' + this.src + '" width="' + this.width + '" height="' + this.height + '" alt="' + this.alt + '"/>\
                        </div>\
                    </div>';

                contentNav += '\
                    <div class="gallery__nav-item">\
                        <div class="gallery__nav-image" style="background-image: url(\'' + this.small_src + '\');">\
                            <img src="' + this.small_src + '" width="' + this.small_width + '" height="' + this.small_height + '" alt="' + this.alt + '"/>\
                        </div>\
                    </div>';

            });

            var content = '\
                <div class="gallery m--full" id="js-ajax-gallery">\
                    <div class="gallery__for">' + contentFor + '</div>\
                    <div class="gallery__nav">' + contentNav + '</div>\
                </div>';

            var width = 600; // 970;
            var countNav = 5;
            var heightFor = width * 0.75;
            var heightNav = width * 0.75 / countNav;
            var marginFor = 4;

            var $gallery, $fancyboxInner, update;

            $.fancybox(content, $.extend({}, App.fancyboxStyle, {
                autoSize: false,
                width: width,
                height: heightFor + marginFor + heightNav,
                scrolling: 'no',
                afterShow: function() {

                    $fancyboxInner = $('.fancybox-inner');

                    $gallery = $('#js-ajax-gallery');
                    var $galleryFor = $gallery.find('.gallery__for');
                    var $galleryNav = $gallery.find('.gallery__nav');

                    // $galleryFor.width(width).height(heightFor);
                    // $galleryNav.width(width).height(heightNav);

                    $galleryFor.slick({
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        focusOnSelect: true,
                        asNavFor: $galleryNav,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true
                                }
                            }
                        ]
                    });

                    $galleryNav.slick({
                        infinite: false,
                        slidesToShow: countNav,
                        slidesToScroll: 1,
                        arrows: true,
                        focusOnSelect: true,
                        asNavFor: $galleryFor,
                    });

                    update = function() {
                        var h = $gallery.height();
                        $fancyboxInner.height(h);
                        $.fancybox.reposition();
                    };

                    $galleryNav.on('setPosition', update);

                },
                onUpdate: function() {
                    update();
                }
            }));

        });

    });

};

App.ProgramFilters = function() {

    // type:    checkbox || radio
    // method:  union || intersection

    function Filters( wrap, isMobile ) {

        var self = this;

        self.$wrap = $(wrap);
        self.isMobile = isMobile;

        self.init();

    }

    Filters.prototype.init = function() {

        var self = this;

        self.name   = self.$wrap.data('name');
        self.type   = self.$wrap.data('type');
        self.method = self.$wrap.data('method');

        self.$items = self.$wrap.find('.js-filters-item');
        self.$items.click(function() { self.itemClick(this); });

        // var _filters = self.isMobile ? filtersMobile : filters;

        filters[ self.name ] = {
            type:   self.type,
            method: self.method,
            items:  [],
        };

    };

    Filters.prototype.loadFilters = function() {

        var self = this;

        var items = filters[ self.name ].items = [];

        self.$items.filter('.is-active').each(function() {
            items.push( $(this).data('id') );
        });

    };

    Filters.prototype.itemClick = function( item ) {

        var self = this;
        var $item = $(item);

        if ( self.type === 'checkbox' ) {

            $item.toggleClass('is-active');

        } else if ( self.type === 'radio' ) {

            if ( !$item.hasClass('is-active') ) {
                self.$items.filter('.is-active').removeClass('is-active');
            }

            $item.toggleClass('is-active');

        }

        filters[ self.name ].items = self.$items.filter('.is-active')
            .map(function() { return $(this).data('id'); }).get();

        if ( !self.isMobile ) filterItems();

    };

    function filterItems() {

        $filteredItems.each(function() {

            var $item = $(this);
            var isVisible = true;

            $.each(filters, function( name, filter ) {

                if ( filter.items.length ) {

                    var itemData = $item.data(name);

                    if ( filter.method === 'union' ) {

                        var _isVisible = false;

                        $.each(filter.items, function( index, value ) {
                            if ( $.inArray(value.toString(), itemData) !== -1 ) {
                                _isVisible = true;
                                return false;
                            }
                        });

                        if ( !_isVisible ) {
                            isVisible = false;
                            return false;
                        }

                    } else if ( filter.method === 'intersection' ) {

                        $.each(filter.items, function( index, value ) {
                            if ( $.inArray(value.toString(), itemData) === -1 ) {
                                isVisible = false;
                                return false;
                            }
                        });

                    }

                }

            });

            $item.toggle(isVisible);

        });

    }

    function filterItemsMobile() {

        $filtersGroups.each(function() {

            var $group = $(this);
            var filter = filters[ $group.data('name') ];

            $group.find('.js-filters-item').each(function() {
                var $item = $(this);
                var id = $item.data('id');
                var isActive = $.inArray(id, filter.items) !== -1;
                $item.toggleClass('is-active', isActive);
            });

            console.log(filter);

        });

        filterItems();

        App.Popup.close();

    }

    function showMobileFilters() {

        var $filtersMobile = $('<div class="block filters m--popup" />');

        $filtersGroups.clone().appendTo($filtersMobile);

        var $buttonBlock = $('<div class="filters__buttons" />').appendTo($filtersMobile);
        $('<button class="button m--primary js-filters-submit" type="button">Применить</button>')
            .appendTo($buttonBlock);

        var content = $filtersMobile.get(0).outerHTML;
        App.Popup.show(content, 'center', function( $content ) {

            var $filtersGroupsMobile = $content.find('.js-filters-group');

            $filtersGroupsMobile.each(function() {
                var f = new Filters(this, true);
                f.loadFilters();
            });

            $content.find('.js-filters-submit').click(filterItemsMobile);

        });

    }

    var filters = {};

    var $filters       = $('.js-filters');
    var $filtersGroups = $filters.find('.js-filters-group');

    var $filtered      = $('.js-filtered');
    var $filteredItems = $filtered.find('.js-filtered-item');

    $filtersGroups.each(function() {
        new Filters(this);
    });

    $('.js-filters-button').click(showMobileFilters);

};

App.Services = function() {

    var $services = $('.services');

    if ( $services.length ) {

        var $body = $services.find('.services__body');
        var $list = $services.find('.services__list');
        // var $items = $services.find('.services__item');

        var narrow;
        var inited = false;

        var $nav = $('<div class="services__nav" />').appendTo($body);

        $list.on('init', function(/* event, slick */) {
            inited = true;
        });

        $list.on('setPosition', function( event, slick ) {
            // var currentPage = Math.ceil( (slick.currentSlide + 1) / slick.options.slidesToShow );
            // var pageCount   = Math.ceil( slick.slideCount / slick.options.slidesToShow );
            // var navContent  = pageCount > 1 ? (currentPage + '/' + pageCount) : '';
            var navContent = '<span>' + (slick.currentSlide + 1) + '</span> / ' + slick.slideCount;
            $nav.html(navContent);
        });

        $(window).on('resize', function() {

            var _narrow = $(window).width() < 992;

            if ( _narrow !== narrow ) {

                narrow = _narrow;

                if ( narrow ) {

                    $list.slick({
                        infinite: false,
                        arrows: true,
                        adaptiveHeight: true,
                    });

                } else if ( inited ) {

                    $list.slick('unslick');
                    $nav.html('');

                }

            }

        }).trigger('resize');

        /* $list.slick({
            rows: Math.ceil($items.length / 2),
            slidesPerRow: 2,
            arrows: true,
        }); */

    }

};

App.AjaxBox = (function() {

    // var scrollTop;

    var $overlay,
        $wrap,
        $content,
        $close,
        $homeMenu;

    var isOpened = false,
        beforeClose,
        scrollbarWidth;

    function init() {

        scrollbarWidth = getScrollbarWidth();

        $('<style type="text/css" />')
            .text('.ajaxbox-margin { margin-right: ' + scrollbarWidth + 'px; }\n' +
                  '.ajaxbox-margin .main-menu { right: ' + scrollbarWidth + 'px; }')
            .appendTo('head');

        $overlay  = $('<div class="ajaxbox" />').hide().appendTo(document.body);
        $wrap     = $('<div class="ajaxbox__wrap" />')/* .hide() */.appendTo($overlay);
        $close    = $('<div class="ajaxbox__close" />').appendTo($wrap);
        $content  = $('<div class="ajaxbox__content" />').appendTo($wrap);

        $homeMenu = $('.home__menu');

        // $close.click(close);
        $overlay.click(overlayClick);

    }

    function show( content, afterShow, _beforeClose ) {

        beforeClose = _beforeClose;

        if ( isOpened ) {

            $content.html(content);

            App.FormMasks($content);
            App.FormPlaceholders($content);

            if ( typeof afterShow === 'function' ) {
                afterShow.call(null, $content);
            }

        } else {

            // scrollTop = $(window).scrollTop();

            // $('.wrapper').css('margin-top', - scrollTop);

            var wrapWidth = $wrap.outerWidth();

            $(document.documentElement).addClass('ajaxbox-lock ajaxbox-margin');

            $(document.body).add($homeMenu).animate({ marginRight: wrapWidth - scrollbarWidth }, 200);

            /* $overlay.fadeIn(100, function() {

                $content.html(content);

                if ( typeof afterShow === 'function' ) {
                    afterShow.call(null, $content);
                }

                $wrap.show()
                    .css({
                        position:   'absolute',
                        top:        0,
                        right:      - $wrap.outerWidth(),
                        width:      $overlay.width(),
                    })
                    .animate({ right: 0 }, 200,
                        function() {
                            $wrap.css({
                                position:   '',
                                top:        '',
                                right:      '',
                                width:      '',
                            });
                        });

                // $overlay.scrollTop(0);

            }); */

            $content.html(content);

            App.FormMasks($content);
            App.FormPlaceholders($content);

            if ( typeof afterShow === 'function' ) {
                afterShow.call(null, $content);
            }

            $overlay.css({ right: - wrapWidth }).show()
                .animate({ right: 0 }, 200, function() {
                    $overlay.css({ right: '' });
                });

            isOpened = true;

        }

    }

    function close() {

        /* $wrap
            .css({
                position:   'absolute',
                top:        0,
                right:       0,
                width:      $wrap.outerWidth(),
            })
            .animate({ right: - $wrap.outerWidth() },
                function() {
                    $wrap.css({
                        position:   '',
                        top:        '',
                        right:       '',
                        width:      '',
                    }).hide();
                    $overlay.fadeOut(100);
                    $(document.documentElement).removeClass('ajaxbox-lock ajaxbox-margin');
                    // $('.wrapper').css('margin-top', '');
                    // $(window).scrollTop(scrollTop);
                }); */

        if ( typeof beforeClose === 'function' ) {
            beforeClose.call(null);
        }

        $(document.body).add($homeMenu).animate({ marginRight: 0 }, 200);

        $overlay.animate({ right: - $wrap.outerWidth() }, function() {
            $overlay.css({ right: '' }).hide();
            $(document.documentElement).removeClass('ajaxbox-lock ajaxbox-margin');
        });

        isOpened = false;

    }

    function overlayClick( event ) {

        if ( event.target === $overlay.get(0) || event.target === $close.get(0) ) {
            close();
        }

    }

    function getScrollbarWidth() {

        var scrollbarWidth = 0;

        var $temp = $('<div />').css({
            position:   'fixed',
            top:        -9999,
            left:       -9999,
            overflowY:  'scroll'
        }).appendTo(document.body);

        scrollbarWidth = $temp.width();

        $temp.remove();

        return scrollbarWidth;

    }

    return {
        init: init,
        show: show,
        close: close,
    };

})();

App.Popup = (function() {

    var $popup,
        $close,
        $content;

    function init() {

        $popup   = $('<div class="popup" />').hide().appendTo(document.body);
        $close   = $('<div class="popup__close" />').appendTo($popup);
        $content = $('<div class="popup__content" />').appendTo($popup);

        $close.click(close);

    }

    function show( content, type, afterShow ) {

        type = type || 'center';

        $content.html(content);

        App.FormMasks($content);
        App.FormPlaceholders($content);

        if ( typeof afterShow === 'function' ) {
            afterShow.call(null, $content);
        }

        var oldType = $popup.data('type');
        $popup.removeClass('m--' + oldType).addClass('m--' + type);
        $popup.data('type', type);

        var top = $(window).scrollTop();
        $popup.css('top', top);

        if ( type === 'left' ) {

            var right = 20;
            var width = $(window).width() - right;
            if ( width > 440 ) width = 440;

            $popup.css({
                left:  -width,
                right: 'auto',
                width: width
            }).show().animate({
                left: 0
            }, 300, function() {
                $popup.css({
                    left: '',
                    right: '',
                    // width: ''
                });
                $close.fadeIn(100);
            });

        } else if ( type === 'right' ) {

            var left = 20;
            var width = $(window).width() - left;
            if ( width > 440 ) width = 440;

            $popup.css({
                right: -width,
                left:  'auto',
                width: width
            }).show().animate({
                right: 0
            }, 300, function() {
                $popup.css({
                    left: '',
                    right: '',
                    // width: ''
                });
                $close.fadeIn(100);
            });

        } else if ( type === 'center' ) {

            var left  = 20;
            var right = 20;
            var width = $(window).width() - left - right;
            if ( width > 440 ) width = 440;

            $popup.css({
                // marginLeft: -width/2,
                width: width
            }).fadeIn(300, function() {
                $close.fadeIn(100);
            });

        }

    }

    function close() {

        var type = $popup.data('type');

        if ( type === 'left' ) {

            var left  = parseInt($popup.css('left'));
            var right = parseInt($popup.css('right'));
            var width = $(window).width() - left - right;

            $close.fadeOut(100, function() {
                $popup.css({
                    left: left,
                    right: 'auto',
                    width: width
                }).animate({
                    left: -width
                }, 300, function() {
                    $popup.hide().css({
                        left: '',
                        right: '',
                        width: ''
                    });
                });
            });

        } else if ( type === 'right' ) {

            var left  = parseInt($popup.css('left'));
            var right = parseInt($popup.css('right'));
            var width = $(window).width() - left - right;

            $close.fadeOut(100, function() {
                $popup.css({
                    right: right,
                    left:  'auto',
                    width: width
                }).animate({
                    right: -width
                }, 300, function() {
                    $popup.hide().css({
                        left: '',
                        right: '',
                        width: ''
                    });
                });
            });

        } else if ( type === 'center' ) {

            $close.fadeOut(100, function() {
                $popup.fadeOut(300);
            });

        }

    }

    return {
        init: init,
        show: show,
        close: close
    };

})();

App.AjaxForms = function() {

    $(document.body).on('click', '.js-ajax-form-button', function( event ) {

        event.preventDefault();

        var params = { form_id: $(this).data('form-id') };
        App.getJSON('get_form', params, showContent, { checkStatus: false });

    });

    $(document.body).on('submit', '.js-ajax-form form', submitForm);

    function submitForm( event ) {

        event.preventDefault();

        var $form = $(this);

        var params = $form.serializeArray();
        App.getJSON('send_form', params, showContent, { checkStatus: false });

    }

    function showContent( data ) {

        if ( data.ok ) {

            // $.fancybox(data.html);

            // App.AjaxBox.show(data.html, function( $context ) {
            App.Popup.show(data.html, 'center', function( $context ) {

                $context.find('.form form').submit(submitForm);

            });

        } else if ( data.errors ) {

            // var $form = $('.ajaxbox__content .form');
            var $form = $('.popup__content .form');

            $form.find('.form__errors').hide().fadeIn(200);

            var $fields = $form.find('.form__field').removeClass('has-error');

            for ( var p in data.errors ) {
                $fields.filter('.attr-'+p).addClass('has-error');
            }

        }

    }

};

App.SeasonSwitcher = function() {

    var snow;

    var $seasonSwitcherItems = $('.js-season-switcher');
    var $homeSeasonImages    = $('.js-home-season-image');

    var season = $(document.body).data('season');
    toggleSnow(season);

    $seasonSwitcherItems.click(function() {

        var $item = $(this);

        if ( !$item.hasClass('is-active') ) {
            $seasonSwitcherItems.filter('.is-active').removeClass('is-active');
            $item.addClass('is-active');
            setSeason($item.data('season'));
        }

    });

    function setSeason( season ) {

        var oldSeason = $(document.body).data('season');

        $homeSeasonImages.each(function() {
            var $image = $(this);
            var src = $image.attr('src');
            src = src.replace('/' + oldSeason + '/', '/' + season + '/');
            $image.attr('src', src);
        });

        $(document.body)
            .removeClass('page--season-' + oldSeason).addClass('page--season-' + season)
            .attr('data-season', season).data('season', season);

        toggleSnow(season);

        App.getJSON('set_season', { season: season }, null, { showActivity: false, checkStatus: false, hideError: true });

    }

    function toggleSnow( season ) {

        if ( season == 'winter' ) {
            startSnow();
        } else {
            stopSnow();
        }

    }

    function startSnow() {

        // if ( App.interfaceName == 'home_page' ) {
            snow = new App.Snow();
        // }

    }

    function stopSnow() {

        if ( snow ) {
            snow.destroy();
            snow = null;
        }

    }

};

// JSSnow
// http://seb.ly/2010/11/javascript-html5-canvas-snow-in-3d/
App.Snow = function() {

    this.SCREEN_WIDTH = window.innerWidth;
    this.SCREEN_HEIGHT = window.innerHeight;

    // this.container;

    // this.camera;
    // this.scene;
    // this.renderer;

    this.mouseX = 0;
    this.mouseY = 0;

    this.windowHalfX = window.innerWidth / 2;
    this.windowHalfY = window.innerHeight / 2;

    this.particles = [];
    this.particleImage = new Image(); // THREE.ImageUtils.loadTexture( "/i/plugins/JSSnow/ParticleSmoke.png" );
    this.particleImage.src = '/i/plugins/JSSnow/ParticleSmoke.png';

    this.init();

};

App.Snow.prototype.init = function() {

    var self = this;

    this.container = document.createElement('div');
    this.container.className = 'jssnow-canvas';
    document.body.appendChild(this.container);

    this.camera = new THREE.PerspectiveCamera( 75, this.SCREEN_WIDTH / this.SCREEN_HEIGHT, 1, 10000 );
    this.camera.position.z = 1000;

    this.scene = new THREE.Scene();
    this.scene.add(this.camera);

    this.renderer = new THREE.CanvasRenderer();
    this.renderer.setSize(this.SCREEN_WIDTH, this.SCREEN_HEIGHT);
    var material = new THREE.ParticleBasicMaterial( { map: new THREE.Texture(this.particleImage) } );

    for (var i = 0; i < 150; i++) {

        var particle = new Particle3D( material);
        particle.position.x = Math.random() * 2000 - 1000;
        particle.position.y = Math.random() * 2000 - 1000;
        particle.position.z = Math.random() * 2000 - 1000;
        particle.scale.x = particle.scale.y =  1;
        this.scene.add( particle );

        this.particles.push(particle);
    }

    this.container.appendChild( this.renderer.domElement );

    document.addEventListener( 'mousemove',  (this.onDocumentMouseMoveHandler  = function( event ) { self.onDocumentMouseMove(event);  }), false );
    document.addEventListener( 'touchstart', (this.onDocumentTouchStartHandler = function( event ) { self.onDocumentTouchStart(event); }), false );
    document.addEventListener( 'touchmove',  (this.onDocumentTouchMoveHandler  = function( event ) { self.onDocumentTouchMove(event);  }), false );
    window.addEventListener  ( 'resize',     (this.onWindowResizeHandler       = function( event ) { self.onWindowResize(event);       }), false );

    this.timer = setInterval( function() { self.loop(); }, 1000 / 60 );

};

App.Snow.prototype.onDocumentMouseMove = function( event ) {

    this.mouseX = event.clientX - this.windowHalfX;
    this.mouseY = event.clientY - this.windowHalfY;

};

App.Snow.prototype.onDocumentTouchStart = function( event ) {

    if ( event.touches.length == 1 ) {

        event.preventDefault();

        this.mouseX = event.touches[ 0 ].pageX - this.windowHalfX;
        this.mouseY = event.touches[ 0 ].pageY - this.windowHalfY;
    }

};

App.Snow.prototype.onDocumentTouchMove = function( event ) {

    if ( event.touches.length == 1 ) {

        event.preventDefault();

        this.mouseX = event.touches[ 0 ].pageX - this.windowHalfX;
        this.mouseY = event.touches[ 0 ].pageY - this.windowHalfY;
    }

};

App.Snow.prototype.onWindowResize = function( event ) {

    this.SCREEN_WIDTH = window.innerWidth;
    this.SCREEN_HEIGHT = window.innerHeight;

    this.windowHalfX = window.innerWidth / 2;
    this.windowHalfY = window.innerHeight / 2;

    this.camera.setViewOffset(this.SCREEN_WIDTH, this.SCREEN_HEIGHT, 0, 0, this.SCREEN_WIDTH, this.SCREEN_HEIGHT);

    this.renderer.setSize(this.SCREEN_WIDTH, this.SCREEN_HEIGHT);

};

App.Snow.prototype.loop = function() {

    for (var i = 0; i < this.particles.length; i++) {

        var particle = this.particles[i];
        particle.updatePhysics();

        if(particle.position.y<-1000) particle.position.y+=2000;
        if(particle.position.x>1000) particle.position.x-=2000;
        else if(particle.position.x<-1000) particle.position.x+=2000;
        if(particle.position.z>1000) particle.position.z-=2000;
        else if(particle.position.z<-1000) particle.position.z+=2000;
    }

    this.camera.position.x += ( this.mouseX - this.camera.position.x ) * 0.05;
    this.camera.position.y += ( - this.mouseY - this.camera.position.y ) * 0.05;
    this.camera.lookAt(this.scene.position);

    this.renderer.render( this.scene, this.camera );

};

App.Snow.prototype.destroy = function() {

    clearInterval(this.timer);

    document.removeEventListener( 'mousemove',  this.onDocumentMouseMoveHandler,  false );
    document.removeEventListener( 'touchstart', this.onDocumentTouchStartHandler, false );
    document.removeEventListener( 'touchmove',  this.onDocumentTouchMoveHandler,  false );
    window.removeEventListener  ( 'resize',     this.onWindowResizeHandler,       false );

    this.camera = null;
    this.scene = null;
    this.renderer = null;

    for (var i = 0; i < this.particles.length; i++) {
        this.particles[i] = null;
    }

    this.particles = [];
    this.particleImage = null;

    this.container.remove();

};

/* App.Snow = function() {

    var SCREEN_WIDTH = window.innerWidth;
    var SCREEN_HEIGHT = window.innerHeight;

    var container;

    var particle;

    var camera;
    var scene;
    var renderer;

    var mouseX = 0;
    var mouseY = 0;

    var windowHalfX = window.innerWidth / 2;
    var windowHalfY = window.innerHeight / 2;

    var particles = [];
    var particleImage = new Image(); // THREE.ImageUtils.loadTexture( "/i/plugins/JSSnow/ParticleSmoke.png" );
    particleImage.src = '/i/plugins/JSSnow/ParticleSmoke.png';

    init();

    function init() {

        container = document.createElement('div');
        container.className = 'jssnow-canvas';
        document.body.appendChild(container);

        camera = new THREE.PerspectiveCamera( 75, SCREEN_WIDTH / SCREEN_HEIGHT, 1, 10000 );
        camera.position.z = 1000;

        scene = new THREE.Scene();
        scene.add(camera);

        renderer = new THREE.CanvasRenderer();
        renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
        var material = new THREE.ParticleBasicMaterial( { map: new THREE.Texture(particleImage) } );

        for (var i = 0; i < 150; i++) {

            particle = new Particle3D( material);
            particle.position.x = Math.random() * 2000 - 1000;
            particle.position.y = Math.random() * 2000 - 1000;
            particle.position.z = Math.random() * 2000 - 1000;
            particle.scale.x = particle.scale.y =  1;
            scene.add( particle );

            particles.push(particle);
        }

        container.appendChild( renderer.domElement );


        document.addEventListener( 'mousemove', onDocumentMouseMove, false );
        document.addEventListener( 'touchstart', onDocumentTouchStart, false );
        document.addEventListener( 'touchmove', onDocumentTouchMove, false );
        window.addEventListener( 'resize', onWindowResize, false );

        setInterval( loop, 1000 / 60 );

    }

    function onDocumentMouseMove( event ) {

        mouseX = event.clientX - windowHalfX;
        mouseY = event.clientY - windowHalfY;
    }

    function onDocumentTouchStart( event ) {

        if ( event.touches.length == 1 ) {

            event.preventDefault();

            mouseX = event.touches[ 0 ].pageX - windowHalfX;
            mouseY = event.touches[ 0 ].pageY - windowHalfY;
        }
    }

    function onDocumentTouchMove( event ) {

        if ( event.touches.length == 1 ) {

            event.preventDefault();

            mouseX = event.touches[ 0 ].pageX - windowHalfX;
            mouseY = event.touches[ 0 ].pageY - windowHalfY;
        }
    }

    function onWindowResize( event ) {

        SCREEN_WIDTH = window.innerWidth;
        SCREEN_HEIGHT = window.innerHeight;

        windowHalfX = window.innerWidth / 2;
        windowHalfY = window.innerHeight / 2;

        camera.setViewOffset(SCREEN_WIDTH, SCREEN_HEIGHT, 0, 0, SCREEN_WIDTH, SCREEN_HEIGHT);

        renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
    }

    function loop() {

        for (var i = 0; i<particles.length; i++) {

            var particle = particles[i];
            particle.updatePhysics();

            if(particle.position.y<-1000) particle.position.y+=2000;
            if(particle.position.x>1000) particle.position.x-=2000;
            else if(particle.position.x<-1000) particle.position.x+=2000;
            if(particle.position.z>1000) particle.position.z-=2000;
            else if(particle.position.z<-1000) particle.position.z+=2000;
        }

        camera.position.x += ( mouseX - camera.position.x ) * 0.05;
        camera.position.y += ( - mouseY - camera.position.y ) * 0.05;
        camera.lookAt(scene.position);

        renderer.render( scene, camera );

    }

}; */

/**
 * Сворачивающиеся блоки
 */
App.Folding = function() {

    // data-duration                            - длительность анимации
    // data-folded="0" || data-folded="false"   - не сворачивать при инициализации
    // data-show                                - заголовок после сворачивания
    //     можно использовать HTML: data-show="&lt;span&gt;Развернуть&lt;/span&gt;"

    // Длительность анимации
    var duration = 300;

    $('.js-folding').each(function( index, element ) {

        // Структура
        var $elem    = $(element);
        var $title   = $elem.find('.js-folding__title');
        var $content = $elem.find('.js-folding__content');

        // Длительность анимации
        var dataDuration = $elem.data('duration');
        if ( typeof dataDuration === 'number' ) {
            duration = dataDuration;
        }

        // Свернуть блок при инициализации?
        var folded = true;
        var dataFolded = $elem.data('folded');
        if ( dataFolded === false || dataFolded === 0 ) {
            folded = false;
        }
        $elem.data('folded', folded);

        // Заменять заголовок при сворачивании/разворачивании?
        var changeTitle = false;
        var titleHide = $title.html();
        var titleShow;
        var dataShow = $elem.data('show');
        if ( typeof dataShow !== 'undefined' ) {
            changeTitle = true;
            titleShow = dataShow;
        }

        // Если нужно, сворачиваем блок
        if ( folded ) {
            $elem.addClass('is-folded');
            if ( changeTitle ) $title.html(titleShow);
            $content.hide();
        }

        // Клик по заголовку
        $title.click(function( event ) {
            var folded = !$elem.data('folded');
            $elem.data('folded', folded);
            $elem.toggleClass('is-folded', folded);
            if ( changeTitle ) $title.html( folded ? titleShow : titleHide );
            $content.stop(true, false).slideToggle(duration);
            event.preventDefault();
        });
    });

    function unfoldSelected() {
        if (location.hash !== '') {
            var $elem = $(location.hash);
            if ($elem.length) {
                var offsetTop = $elem.offset().top;
                $('html, body').animate({ scrollTop: offsetTop }, 100);
                if ($elem.data('folded')) {
                    $elem.find('.js-folding__title').click();
                }
            }
        }
    }

    $(window).on('hashchange', unfoldSelected).trigger('hashchange');

};
